module.exports = __webpack_public_path__ + "static/media/icon_Benchmarking206.2d777c45.png~merged";